import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ButtonType = 'primary' | 'secondary' | 'tertiary' | 'outline';
export type ButtonStyle = 'flat' | 'b-shadow';
export type ButtonHeight = 'small' | 'medium' | 'large' | 'x-large';
export type ButtonWidth = 'compact' | 'expanded' | 'full-width';
export type IconPosition = 'left' | 'right';
export type IconVariant = 'arrow' | 'add' | 'x' | 'remove' | 'refresh' | 'info';

@Component({
  selector: 'broker-new-button',
  templateUrl: './new-button.component.html',
  styleUrls: ['./new-button.component.scss']
})
export class NewButtonComponent {
  @Input() id = '';
  @Input() type: ButtonType = 'primary';
  @Input() style: ButtonStyle = 'flat';
  @Input() height: ButtonHeight = 'medium';
  @Input() width: ButtonWidth = 'compact';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() icon: IconVariant = null;
  @Input() iconPosition: IconPosition = 'left';
  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();
}
